import React from 'react'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import TaskMenuController from '../TaskMenu/TaskMenuController'
import TaskHeaderController from 'controllers/TaskManager/TaskSubControllers/TaskHeader/TaskHeader'
import AlertBox from 'components/AlertBox/AlertBox'
import FinalizeTaskDialog from '../FinalizeTaskController/FinalizeTaskDialog'
import InfoList from 'components/InfoList/InfoList'

import styles from '../Dialog.module.sass'
import useSubmitTask from 'hooks/useSubmitTask'

const GenericCancelController = (props) => {
	const { i18n } = useGlobal()
	const {
		data,
		requisition,
		resolve,
		dismiss,
		id,
		isRequisition = false,
	} = props
	const { alertMessage, infoItems, reason, task } = data

	const { error, submitting, resolveTask } = useSubmitTask(task?.id)

	const onSubmit = () => {
		const body = {
			processId: task.processId,
			processRequestId: task.processRequest.processRequestId,
		}

		resolveTask(body, 'nullify')
			.then(() => resolve())
			.catch(() => {})
	}

	const customError = error?.map((err) => {
		return {
			title: i18n`Error`,
			text: err,
		}
	})

	return (
		<>
			{submitting && (
				<FinalizeTaskDialog
					dismiss={dismiss}
					submitting={submitting}
					task={task}
					submissionType={'nullify'}
				/>
			)}
			<div className={styles['form-container']}>
				<TaskHeaderController
					task={task}
					displayRequisition={isRequisition}
					hideSpecialtyAndAppointment={isRequisition}
					requisition={requisition}
					hideAuthor={true}
					showStatus={false}
				/>
				<form
					id={`form_${id}`}
					className={styles['form']}
					onSubmit={(e) => {
						e.preventDefault()
						onSubmit()
					}}
				>
					{customError && customError.length > 0 && (
						<AlertBox
							className={styles['alert-box']}
							type='error'
							items={customError}
						/>
					)}

					{alertMessage && (
						<AlertBox
							className={styles['cancel-alert-message']}
							type='warning'
							items={[{ ...alertMessage }]}
						/>
					)}

					{infoItems.length ? (
						<InfoList
							className={styles['info-list']}
							items={infoItems}
							orientation='vertical'
						/>
					) : null}

					{reason && (
						<InfoList
							className={styles['info-list']}
							items={[{ ...reason }]}
							orientation='vertical'
						/>
					)}
				</form>
			</div>
			<TaskMenuController
				data={{
					formId: id,
					options: ['postpone', 'forward', 'refuse_request'],
					submitting,
					submissionType: 'nullify',
				}}
			/>
		</>
	)
}

export default GenericCancelController
